export default __webpack_public_path__ + "static/media/no-matches-men-bg.794c6a4e.webp";